import React from 'react';
import styles from '../../asset/css/termsCommon.module.scss';

export const Terms: React.FC = () => (
    <div className={styles.wrap}>
        <h1>教室・スクール運営事業者の利用規約</h1>
        <div>
            本規約は、「oriori」へ利用申込を行った者と株式会社NumberLeaps(以下「当社」)との間の契約関係について定めるものです。
            <br />
            また、本規約は、自己または他人のために生徒募集に関する情報を提供しようとしている個人または組織（複数の者のために購入を行う代理店を含みますが、それに限定されません。）のために本サイトにアクセスし、もしくはこれを使用し、または本利用規約を承諾する意思を示したすべての教室・スクール運営企業およびその他のユーザーに適用されます。
        </div>
        <h2>第１条(定義)</h2>
        <div>
            本規約で用いる用語の定義は以下の通りとします。
            <br />
            (1)「ユーザー」とは、教室・スクール運営企業、教室・スクール事業者としての資格で本サイトにアクセスする個人または組織を意味します。
            <br />
            (2)「本件サービス」とは、本規約第３条に規定される当社がユーザーに対し提供するサービスをいい、有償であるか無償であるかを問わないものとします。
            <br />
            (3)「本契約」とは、当社と店舗会員との間で成立する、本規約等（第3条第1項で定義）を内容とする本件サービスの利用に関する契約をいいます。
            <br />
            (4)「教室・スクールアカウント」とは、教室・スクール運営企業情報及びオンライン教室を含む教室・スクール各店舗情報が紐ついたアカウントを指します。
            <br />
        </div>
        <h2>第２条(適用範囲)</h2>
        <div>
            1. 本規約は、店舗会員が本件サービスを利用するにあたり、当社とユーザーとの間に適用されます。
            <br />
            2.
            当社は、本件サービスの各々につき、当社の判断にて随時、個別の利用規約(以下「個別規約」)を定めることができるものとします。個別規約が定められた場合は、当該個別規約が対象とする本件サービスには、当該個別規約において別途の定めがない限り、本規約に加え、当該個別規約が適用されるものとします。
            <br />
            3.
            個別規約と本規約に矛盾が生じるときは、当該個別規約が優先するものとし、個別規約に定めのない事項については、本規約が適用されるものとします。なお、個別規約における用語の定義は当該個別規約で定める場合を除き、本規約と同一とします。
            <br />
        </div>
        <h2>第３条(本件サービス)</h2>
        <div>
            1. 当社は、ユーザーに対して、本規約および個別規約（以下「本規約等」）に基づき以下の各号に定めるサービスを提供します。
            <br />
            (1)
            生徒募集に関する情報(教室・スクール名、電話番号、住所、商標、商号、ロゴ、その他ユーザーから提供された一切の情報を含み、以下総称して「教室・スクール情報」という)の全部または一部を、当社の管理するサーバーに登録し、当社が運営する「oriori」（以下「当サイト」）に掲載し、教室・スクール情報が掲載される当サイト内のページを（以下「教室・スクールページ」)、公衆送信等の方法によりインターネットユーザーに提供するサービス
            <br />
            (2)ユーザーの通信端末から当社の管理するサーバーにアクセスし、ユーザー自らが教室・スクール情報の登録および変更ができる機能、その他ユーザーが本件サービスを利用するために必要な機能を有する管理システム(以下「管理システム」)を提供するサービス
            <br />
            2. 当社は、ユーザーに対して、前項に規定するサービス、ならびに以下の各号に定める機能およびサービスを提供するものとします。
            <br />
            (1)ユーザーからの要請に基づき、当社が別途定める方法・要領により、電話またはパソコンを通して、教室・スクールページの作成および編集の支援、ならびにこれらに関するアドバイス等を行うサービス
            <br />
            (2)その他当社が「有料プラン」として規定するもの
            <br />
            3.
            ユーザーは、前各項に定めるサービスのほか、当社が別途提供する各種のサービス(以下「オプションサービス」)の利用を、当社所定の方法に従って申し込み、当社の承諾を得た場合、本規約等に基づきこれを利用することができます。ただし、当社は、当該申込を承諾する義務を負いません。
            <br />
            4. 当社は、本サイトをきっかけとして「ユーザー」と「習い事を探している保護者及び当事者」間で締結される取引の当事者とはなりません。
            <br />
        </div>
        <h2>第４条(本契約の申込と成立)</h2>
        <div>
            1.
            本件サービスの利用を希望する者(以下「利用希望者」)は、当社所定の方法により本件サービスの利用の登録を行うものとします。なお、登録をもって、本規約およびorioriのすべての規約（orioriのプライバシー規約およびCookieポリシーを含みます。）がユーザーに適用されることに同意します。
            <br />
            2.
            教室・スクールアカウントは、業務利用のためのものであり、個人利用のためのものではありません。ユーザーのメールアドレスが第三者によって不適切にまたは偽って使用された場合、当社
            はその責任を負わず、すべての責任を否認します。
            <br />
            3.
            ある状況においては、複数のユーザーが同一の教室・スクールアカウントにリンクされる場合があります。具体的には、教室・スクール運営企業及び教室・スクール運営者のアカウントの主たるアカウント所有者（以下「管理者」といいます。）が他のユーザーを同一アカウントに招待した場合に、複数のユーザーが同一の教室・スクールアカウントにリンクされた状態になります。管理者はそれらの他のユーザーに対し、アカウント内でさまざまなレベルのアクセスおよび機能（以下「役割」といいます。）を付与することができます。管理者であるユーザーは、あるユーザーに1つまたは複数の役割を追加する場合、当社に対し、自らがそのアカウントの権限ある代表者であって、そのデータおよびアクセス権を共有する権限を有していることを表明するものとします。さらに、ユーザーは、このデータおよびアカウントへのアクセス権を共有した結果として発生する申し立て、請求、措置、訴訟、要求、損害、責任、義務、損失、和解、判決、経費および費用（弁護士の報酬および経費を含みますが、これらに限定されません。）について、当社に補償を行い、当社に損害を及ぼさないことに同意します。ユーザーは、上記の記述の正確性に関して当社が責任を負うものではなく、その正確性についてユーザーが責任を負うことに同意します。管理者より招待を受けたユーザーがリンクされたアカウントを使用する場合、一定の役割へのアクセス権を有するユーザーは、アカウント情報の一部または全部（リンクされたアカウント内の他のすべてのユーザーおよびorioriの機能を通じて教室・スクールへ問合せをした保護者ないしは本人に関する情報および請求書の情報を含ますが、これらに限定されません。）にアクセスできる場合があり、ユーザーは、そのようなアクセスに同意します。
            <br />
            4.
            有料プランの申込においては、ユーザーが管理システムを通じ、申込者の有効なクレジットカード情報を登録したときをもって、当社と利用希望者との間で本規約等を内容とする本契約が成立したものとみなします。ユーザーの教室・スクールアカウントに、本サービスの支払いのためのクレジットカードが登録されている場合、当社は、ユーザーが注文した追加の製品またはサービスについてもそのカードに請求できるものとします。
            <br />
            5.
            当社は、当社所定の審査基準に従って審査を行い、当社が教室・スクールアカウントとして不適切と判断した場合、ユーザーに事前通告をせずに、本サービスの利用を停止することができます。
            <br />
            6.
            当社からユーザーに対する通知の際の連絡方法は、当社の選択により、ユーザーが管理システム内に登録した住所・メールアドレスに送付または送信する方法のいずれかにより行います。現実に通知が到達したか否かに関わらず、当該方法のいずれかにより送付または送信した時点において、当社からユーザーに対する通知がなされたものとみなします。なお、ユーザーが電子メールアドレスや住所情報の変更登録を怠ったこと等により当該通知が不到達となっても、通常到達すべきときに到達したとみなします。
            <br />
            7.
            ユーザーは、当社からの通知内容を逐次確認する義務を負うものとします。ユーザーが当該確認を怠ったことにより発生したユーザーの損害に関しては、当社は一切の責任を負いません。
            <br />
        </div>
        <h2>第５条(掲載開始タイミング・有料プラン適用タイミング)</h2>
        <div>
            1. 管理システムにて教室・スクール情報の入力が完了し、掲載開始指示をシステム上で行った時点で教室・スクール情報の掲載を開始します。
            <br />
            2. 有料プラン適用については、管理システムにて予算情報の設定及びクレジットカード情報の登録が完了した時点で行います。
            <br />
        </div>
        <h2>第６条(利用料金および支払方法)</h2>
        <div>
            1.
            教室・スクール情報登録の利用料金は無料とします。ただし、個別規約または特約において別途の定めをした場合には、これに従うものとします。また、ユーザーが本サービスを利用するための通信費用等は、ユーザーが負担するものとします。
            <br />
            2.
            有料プランは教室・スクールアカウント内に登録した教室・スクールの店舗（オンライン教室・通信教育を含む）ごとに適用され、個別店舗ごとに課金されます。有料プランを適用した場合の店舗（オンライン教室・通信教育を含む）毎の利用料金は、本件サービスのシステム利用料として月額3,300円（税込み）、orioriの問合せ機能を通じて発生した問合せ1件に対して1件あたり3,300円（税込み）とします。ただし、月ごとの契約期間内に発生した最初の問合せについては課金対象外とし、2件目以降から課金が発生いたします。また、教室・スクールアカウント内に店舗（オンライン教室・通信教育を含む）が1店舗しか登録されていない場合は、システム利用料としての月額3,000円のみを利用料金とし、問合せ従量課金分は控除します。
            <br />
            (1) ユーザーは、利用料金およびそれにかかる消費税を当社が指定した期日および方法により支払うものとします。
            <br />
            (2)
            利用料金は契約成立日から発生します。ただし、特約等において別途定めがある場合は、これに従うものとします。また、当月の（N）日から開始したら、翌月の（N-1）日までを有料プラン適用期間とします。また管理システム上で有料プランの解約設定をした場合を除き、有料プランは自動更新され、従前と同一内容でさらに1ヶ月有料プランが更新されます。問合せ従量課金については、当月1日～末日までの問合せ数をカウントして、翌月ご請求いたします。また、いかなる場合にも「問合せ従量課金の無効申請」は認めません。
            <br />
            (3)
            有料プランを契約期間内に解約した場合には、それ以降の問合せ従量課金は発生いたしません。ただし、システム利用料の月額3,300円（税込み）は全額請求とし、利用日数による日割計算は行いません。
            <br />
            (4) 利用料金の支払方法は、原則として当社が認めたクレジットカードによる支払とします。
            <br />
            3.
            当社は、法令の変更あるいは経済環境の変化があった場合、掲載条件を予告なく改定することがあります。なお、同じく利用料金その他本件サービスの対価の額の改定をすることがあります。
            <br />
        </div>
        <h2>第７条(アカウント管理)</h2>
        <div>
            1.
            ユーザーは、当社から発行されたID、パスワードの管理責任を負うものとし、第三者に利用させ、または譲渡・貸与・開示・名義変更等をしてはならないものとします。
            <br />
            2.
            ユーザーは、教室・スクールアカウントの管理不十分、使用上の過誤、第三者の使用等に起因する損害につき、自ら責任を負うものとし、教室・スクールアカウントが第三者によって不正に使用されていることが判明した場合には、速やかに当社に連絡するものとします。
            <br />
            3.
            教室・スクールアカウントが不正に利用された場合であっても、当社は当該利用がユーザーによる適正な利用とみなし、当該利用により発生した一切の損害等につき何らの責任も負わないものとします。
            <br />
            4.
            ユーザーは教室・スクール情報に変更がある場合には、管理システムを通じて変更・修正をし、常に最新かつ正確な情報の掲載を維持するものとします。
            <br />
            5.
            ユーザーは、orioriの問合せ機能を利用した「習い事を探している保護者及び当事者」に対応するメッセージ、メールまたはメール通知を受信することがあります。いかなる場合も、そのようなメッセージまたは通知は、便宜のために送られるものにすぎず、ユーザーは、それらに依拠すべきではありません。たとえば、ユーザーが「習い事を探している保護者及び当事者」との面談を希望する場合、「習い事を探している保護者及び当事者」がその面談のことを認識するように別途フォローアップして連絡するのはユーザーの責任です。本サービス経由の通知に依拠しないようにしてください。
            <br />
        </div>
        <h2>第８条(本件サービスについて)</h2>
        <div>
            1．当社は、事前に告知することなく本件サービスの詳細(当サイト、教室・スクール情報ページまたは管理システムのデザイン、構成または機能等)を変更することがあります。
            <br />
            2.
            当社は、事前に告知することなく当社の都合により本件サービスの全部または一部の提供を終了することがあります。本告知は、当サイト上にて行います。
            <br />
            3. 当社は、次のいずれかに該当する場合、事前に告知することなく本件サービスを一定期間停止する場合があります。
            <br />
            (1) システム等の保守または仕様の変更を行なう場合
            <br />
            (2) 火災、天災、停電、事変その他非常事態が発生し、または発生するおそれがあり、情報提供が困難になった場合
            <br />
            (3) その他、運用上の合理的な理由で停止の必要があると判断された場合
            <br />
            4.
            前３項に基づき、当社が本件サービスを変更・終了・停止したことにより、ユーザーまたは第三者に損害や不利益が発生しても、当社は一切の責任を負わないものとします。
            <br />
        </div>
        <h2>第９条(プライバシー)</h2>
        <div>
            個人情報の取り扱いに関しては、当社が別途定めるプライバシーポリシーの定めによるものとし、ユーザーはこのプライバシーポリシーに従って当社が教室・スクール情報を取り扱うことについて同意するものとします。
            <br />
        </div>
        <h2>第10条(掲載情報)</h2>
        <div>
            1.
            ユーザーは、本契約期間中、当社所定の方法に従って自らの責任において教室・スクール情報ページ等への情報の登録もしくは変更ができるものとします（以下、教室・スクールページ等に掲載された情報を「掲載情報」といいます）。その際、下記に定める事項、不当景品類及び不当表示防止法その他の法令、および当社の定めるその他の事項を遵守するものとします。
            <br />
            (1)
            掲載情報あるいはリンク先の記載内容が各種法令（条例、政令、通達、ガイドライン、業界団体の自主基準等の一切を含む。以下同様）に違反していないこと
            <br />
            (2)
            当社、他のユーザーまたは第三者に対し、著作権等の知的財産権、肖像権、名誉・プライバシーの侵害、誹謗中傷、その他一切の権利の侵害もしくは何らかの不利益を与える行為またはその恐れのある行為をしないこと
            <br />
            (3) ユーザーが運営するサービスが公序良俗に反さないこと
            <br />
            (4) 犯罪行為とはならない、あるいは犯罪行為に結びつかないこと
            <br />
            (5) 虚偽の内容あるいは誤認されやすい内容・表現でないこと
            <br />
            (6) マルチ商法等、迷惑な商行為がないこと
            <br />
            (7) 風俗営業の店ではないこと
            <br />
            (8) その他、当社が本件サービスの信用を損なうと判断するものでないこと
            <br />
            2.当社は、掲載情報に関して、当社が定める掲載ガイドライン等に沿って審査を行うことがあります。当社は、掲載情報(リンク先も含む)が各種法令または掲載ガイドライン等に抵触する場合等、当社の判断により、その情報の全部または一部を削除または編集・変更すること、もしくは掲載を拒否することができるものとします。
            <br />
            3.
            当社は、前項に加え、当社の判断により、ユーザーへの何らの事前通知なく、教室・スクール情報ページの編集・変更・削除を行うことができるものとします。なお、当社はその理由の如何を問わず掲載情報ないし教室・スクール情報ページの編集・変更・削除の義務を負うものではありません。
            <br />
            4.
            ユーザーは、理由の如何を問わず本サービス利用終了後においては、教室・スクール情報ページを任意で編集・変更・削除することはできず、掲載情報の掲載、修正、削除に関しては当社の任意の判断に従うことに同意するものとします。
            <br />
            5.
            関係法令または掲載ガイドライン等に抵触する口コミと当社が判断した場合は、当社は予告なく当該口コミを当サイト上から削除する場合があります。なお、当社はその理由の如何を問わずかかる削除の義務を負うものではありません。
            <br />
            6.
            教室・スクール情報ページ、掲載情報または口コミを編集・変更・削除したこと、またはこれらを削除等しなかったことにより、ユーザーもしくは第三者に発生した損害について、当社は一切の責任を負いません。
            <br />
        </div>
        <h2>第11条(禁止事項)</h2>
        <div>
            1. ユーザーは、以下の各号に該当する行為(以下の各号に該当するおそれがあると当社が判断する行為を含む)を行ってはならないものとします。
            <br />
            (1) 不当景品類及び不当表示防止法その他の各種法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置に違反する行為
            <br />
            (2) 犯罪に結びつく行為
            <br />
            (3) 公序良俗に反する行為
            <br />
            (4)
            当サイトに口コミを店舗会員自らが掲載し、または第三者に依頼して掲載させること、店舗会員の商品・サービスの質ないし内容その他消費者の判断に錯誤を与える恐れのある行為
            <br />
            (5)
            他のユーザーその他の第三者に対し、著作権等の知的財産権、肖像権、名誉・プライバシーの侵害、誹謗中傷、その他一切の権利の侵害もしくは何らかの不利益を与える行為
            <br />
            (6) 当サイト上で店舗会員の運営する店舗に関わる情報以外を宣伝する行為
            <br />
            (7) 本件サービスの運営・維持を妨げる行為
            <br />
            (8) 虚偽の情報を故意に登録する行為
            <br />
            (9) 本件サービスに関し利用しうる情報を改竄する行為
            <br />
            (10)有害なコンピュータプログラム等を送信または書き込む行為
            <br />
            (11)当サイトに掲載されている情報その他本件サービスで取得可能な情報を、他のサイトに転載し、またはインターネット以外の媒体に転用する行為
            <br />
            (12)宗教活動、政治活動等の目的で本件サービスを利用する行為
            <br />
            (13)その他、当社が不適当と判断する行為、または、当社が当サイトの信用を損なうと判断する行為
            <br />
            2.
            ユーザーが前項に違反すると判断する場合、当社は、何らの催告なしにユーザー登録情報及び教室・スクールアカウントを削除（本契約の解約）することができるものとします。また、かかる行為により掲載された情報等に関して、当社は一切の義務を負わないものとし、当該情報等を当サイト上から削除し、または当該行為を行ったユーザーに対して当該行為の差止を請求できるものとします。なお、当社はその理由の如何を問わずかかる削除または差止請求の義務ないし違反行為の監視の義務を負うものではありません。
            <br />
            3．ユーザーが第1項に定める行為によって当社に損害を与えた場合、当社はユーザーに対して損賠賠償の請求を行うことができるものとします。
            <br />
        </div>
        <h2>第12条(著作権・知的財産権・使用許諾)</h2>
        <div>
            1.
            ユーザーが本件サービスを通じて文章や画像等その他一切の情報の登録・提供を行った時点で、当該情報の内容の国内外における複製権、公衆送信権、翻訳権・翻案権等の全ての著作権およびその他の著作権法上の権利(当社から第三者に対する再利用許諾権を含む)を、店舗会員は無償で無期限に当社に対して許諾したものとします。また、ユーザーは当社および当社が定める第三者に対し著作者人格権を行使しないものとします。
            <br />
            2.
            当社は、本件サービスの提供または販促活動に必要な限度において、ユーザーが本件サービスを通じて登録・提供した情報の全部または一部をユーザーへの事前の通知・承認および対価の支払いを要せず、内容の変更・複写・移動を行うほか、自由に利用等する（以下「利用等」）ことがあり、ユーザーはあらかじめこれを無償で無期限に許諾するものとします。
            <br />
            3.
            本契約期間中または契約終了後にかかわらず、当社が本条により情報を利用等したことにより、ユーザー、もしくは第三者において問題および損害が生じた場合、当社は一切の責任を負いません。
            <br />
            4．ユーザーは、ユーザー以外の第三者が著作権等の権利を有する情報等を登録・提供する場合、事前に権利を有する当該第三者から当該情報等をユーザーおよび当社が使用することについて許諾を受けなければなりません。ユーザーは、本件サービスにおいて、肖像権や知的財産権等に関して権利を侵害しているもの、または侵害する可能性のある情報や使用許諾に問題のある情報を登録・提供してはならないものとします。
            <br />
            5.
            当社は、掲載される教室・スクール情報ページを、当社あるいは当社のサービスの宣伝や販売促進活動等において利用することがありますが、原則としてユーザーはこれを承諾するものとします。ここでいう掲載情報にはユーザーが権利を有する店舗の名称、商標、ロゴ等を含みます。これらの利用を承諾できない場合は、予め当社にその旨を通知するものとします。
            <br />
        </div>
        <h2>第13条(個人情報の取り扱い、守秘義務)</h2>
        <div>
            1.
            ユーザーは、直接間接を問わず本件サービスを通じて知り得た一切の個人情報（当サイトまたは教室・スクール利用者の氏名、電子メールアドレス、電話番号、性別、生年月日、住所、問合せ履歴その他当サイトまたは教室・スクール利用者に関する一切の情報等、以下総称して「本件個人情報」）を、本契約期間中または本契約の終了後にかかわらず、個人情報の保護に関する法その他の各種法令を遵守して取り扱い、安全かつ適切な方法で厳重に管理し、本件サービスの利用の目的以外に使用してはならず、また第三者に開示し、使用させてはならないものとします。また、本件個人情報の利用に関し、次の各号を遵守するものとします。
            <br />
            (1) ユーザーが本件個人情報の本人その他第三者から損害賠償請求その他の請求を受けたときは、自己の費用と責任によりこれを解決すること
            <br />
            (2)
            当社が本件個人情報の本人その他第三者から損害賠償請求その他の請求を受け、被害を被った場合には、当該損害(合理的な範囲における弁護士費用および裁判等に関する費用を含む)を補償すること（ただし、当社の故意または重過失による場合を除く）
            <br />
            2.
            ユーザーは、本契約期間中または本契約の終了後にかかわらず、本契約に関連して知り得た情報、本契約の内容、その他当社の機密に属すべき一切の事項を第三者に漏洩してはならないものとします。
            <br />
        </div>
        <h2>第14条(ユーザーの責任)</h2>
        <div>
            1.
            ユーザーは、本件サービスの利用にあたっては、本規約等の他、当社の定める手順・セキュリティ手段を遵守するものとし、この遵守を怠った場合その他当社が本件サービスの運営上不適当と判断した場合、当社は、当該行為を停止させ、または本件サービスの利用の停止および法的措置を含む損害賠償請求等、必要な措置を取ることができるものとします。
            <br />
            2.
            ユーザーは、本件サービスの利用に際しては当社指定のシステム環境に適合した文字（日本語表示）やメール等の諸設定を適切に行うこととします。この条件にあてはまらない場合の動作結果やそれがもたらす諸影響に関して、当社は一切責任を負いません。また、上記条件を満たしていても、その他、ユーザーその他の当サイト利用者のパソコンおよび携帯電話の環境設定に関するいかなる事情（当社の管理の及ばない全ての原因を含む）により、当サイトが正しく作動しない場合も、それがもたらす諸影響に関して、当社は一切責任を負いません。
            <br />
            3.
            ユーザーは、本件サービスの利用に際し、自ら行った行為について責任を負うものとし、第三者に損害を与えた場合、自己の責任と費用負担で解決するものとします。
            <br />
        </div>
        <h2>第15条(免責等)</h2>
        <div>
            1.
            当社は、ユーザーが本件サービスの利用またはその結果を利用したことにより、ユーザーに発生したいかなる不利益・損害(その原因の如何を問わない)について、その損害を賠償する責を負わないものとします。また、本件サービスに関連して第三者に発生した不利益・損害についても同様とします。
            <br />
            2.
            本件サービスに起因し、またはこれに関連して、当社の故意・重過失によりユーザーが損害を被った場合に限り、当社は、ユーザーが当社に本件サービスの対価として支払った総額を限度額として損害を賠償するものとします。
            <br />
            3.
            本件サービスにおいて、ユーザーから登録・提供された情報(プログラムを含む)によって第三者の知的財産権(著作権、意匠権、特許権、実用新案権、商標権、営業秘密を含む)、名誉、プライバシーその他第三者の権利または利益を侵害し、当社が損害賠償の支払を余儀なくされた場合は、当社は当該権利または利益侵害の原因となる情報を提供したユーザーに対し、その損害および当該権利または利益侵害に基づく請求への対応に関わる一切の費用(訴訟費用、賠償金、弁護士費用を含む)を請求できるものとします。
            <br />
            4.
            本件サービスの利用に関連し、ユーザーが他のユーザー、当サイトもしくは教室・スクール利用者、または第三者から損害賠償請求等の請求がなされ、または訴訟が提起された場合、当該店舗会員は、自らの費用と責任において当該請求または訴訟を解決するものとし、当社は一切の責任を負わないものとします。また、第三者からの苦情等の内容によっては、掲載情報を削除し、または一時的に停止させていただくことがあります。
            <br />
            5. 当社は、本件サービスに関して、不具合やエラー等が生じたとしても責任を負いません。
            <br />
            6.
            当社は、停電・天変地異・通信回線の事故等の不可抗力、通信事業者の不履行、インターネットインフラ・サーバーダウン・ウィルス等のシステム上の不具合、緊急メンテナンスの発生その他の事由によって、データ消去および変更ならびに本件サービスにかかるシステムの停止等が生じ、ユーザーに損害が生じた場合であっても、責任を負いません。
            <br />
            7.
            その理由の如何を問わず、ユーザーのアカウントを使用して行われたすべての行為に関してはユーザーが責任を負い、ユーザーに損害が生じた場合であっても当社は責任を負いません。
            <br />
            8.
            ユーザーは、本件サービスのセキュリティ機能において、現時点での技術上取れる水準で安全かつ適切な措置を取ったとしてもなお限界があること、当社がユーザーのプライバシーや秘密等を完全または万全に保つことの保証ができないことを了解の上、本件サービスを利用するものとします。
            <br />
        </div>
        <h2>第16条(有効期間)</h2>
        <div>
            1.
            本契約期間は、無料プランと有料プランとを問わず、教室・スクールアカウントを開設した日から起算して1年後の応答日の前日を含む月の末日(以下「当初契約期間満了日」)までとします。ただし、特約等において別途定めがある場合は、これに従うものとします。ただし有料プランの適用期間については、前述に定めた通りとする。
            <br />
            2.
            当初契約期間満了日を含む月の15日までに、当社またはユーザーから、当社所定の方法による別段の意思表示のない場合には、従前と同一内容でさらに1ヶ月本契約が更新されるものとします。
            <br />
            3.
            前号により本契約が更新された後は、更新後の契約期間満了の日を含む月の15日までに、当社または店舗会員から、当社所定の方法により、本契約更新をもって本契約を終了とする旨の意思表示がない場合には、従前と同一内容でさらに1ヶ月本契約が更新されるものとし、以後も同様とします。
            <br />
        </div>
        <h2>第17条(ユーザーによる解約)</h2>
        <div>
            1.
            ユーザーは、契約期間中においても、希望する解約の日(以下「解約希望日」)以前に、当社の指定する方法に従って解約の旨を通知することにより、解約希望日をもって本契約を終了させることができるものとします。ただし、解約希望日までに当社の解約手続が完了しない場合は、解約手続の完了日をもって本契約は終了するものとします。
            <br />
        </div>
        <h2>第18条(当社による解約)</h2>
        <div>
            1.
            当社は、ユーザーが次のいずれかの事由に該当した場合には、何らの催告なしに本契約を直ちに解約することができるものとします。この場合において、ユーザーが有料プラン利用ユーザーである場合は、解約日までの当社に対する未払いの利用料金および当初契約期間満了日までの利用料金(消費税相当額を含む)等の当社に対する債務全額をただちに支払うものとします。
            <br />
            (1) 本規約等の条項に違反した時
            <br />
            (2) 掲載情報あるいはリンク先の記載内容が各種法令に反している、あるいは不適切であると当社が判断した時
            <br />
            (3) 登録時に虚偽または事実に反する申告が行われた時
            <br />
            (4) 掲載を継続することが、当社の利益や信用を損なうと当社が判断した時
            <br />
            (5) 手形または小切手の不渡りが発覚した時
            <br />
            (6) 破産手続開始、民事再生手続開始、会社更生手続開始または特別清算開始の申立てがされた時
            <br />
            (7) 差押え、仮差押え、仮処分、その他の強制執行、または滞納処分および滞納処分の申立てを受けた時
            <br />
            (8) 前3号の他、ユーザーの信用状態に重大な変化が生じた時
            <br />
            (9) 解散または営業停止状態となった時
            <br />
            (10)営業方法等について行政当局による注意または勧告、もしくは行政処分を受けた時
            <br />
            (11)ユーザーが当社のコンピュータに保存されているデータを当社に無断で閲覧、変更もしくは破壊した時、またはその恐れがあると当社が判断した時
            <br />
            (12)営業方法等が公序良俗に反しまたは本件サービスにふさわしくないと当社が判断した時
            <br />
            (13)前各号のいずれかに準ずる事由があると当社が判断した場合
            <br />
            (14)その他ユーザーによる本契約の履行が困難であるなど、ユーザーが本件サービスのユーザーとして不適切と当社が判断した場合
            <br />
            2.
            当社は、前項各号にかかわらず、本契約期間中においても、ユーザーに対し事前に通知することにより、いつでも、本契約を解約することができるものとします。この場合において、当該ユーザーが有料プラン利用ユーザーである場合は、解約日が属する月の末日までの当社に対する未払いの利用料金全額を当社が指定した期日に当社に支払うものとします。
            <br />
        </div>
        <h2>第19条(反社会的勢力の排除)</h2>
        <div>
            1.
            ユーザーは、当社に対し、ユーザーおよびその役員、使用人が暴力団、暴力団員、暴力団関係団体、暴力団関係者、その他の反社会的勢力(以下あわせて「暴力団等」)でないことを、および、次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。
            <br />
            (1) ユーザーの経営者、役員ないし使用人が、暴力団等であること、または過去に暴力団等であったこと
            <br />
            (2)暴力団等が事業活動を支配する個人または法人であること
            <br />
            (3) ユーザーの経営者、役員ないし使用人が、刑事事件によって逮捕もしくは刑事訴追を受けていること
            <br />
            (4)自らまたは第三者を利用して、当社、他のユーザーまたは第三者に対して、詐術、粗野な振る舞い、合理的範囲を超える負担の要求、暴力的行為または暴力的言辞を用いる等していること
            <br />
            (5)当社、他のユーザーまたは第三者に対し、自身が暴力団等である旨を伝え、または自身の関係団体もしくは関係者が暴力団等である旨を伝える等していること
            <br />
            2.
            ユーザーが1つでも前項に反すると当社が判断した場合は、ユーザーに事前に通知することなく、当社は直ちに本契約等、ユーザーとの間の一切の契約を解約することができるものとします。この場合、ユーザーは、未払いの利用料金および当初契約期間満了日までの利用料金（消費税相当額を含む）等の当社に対する債務全額をただちに支払うものとします。
            <br />
            3.
            店舗会員は、当社が前項により本契約を解約したことにより生じた損害について、当社に対し何らの請求も行わず、当社は損害賠償の責任を一切負いません。
            <br />
        </div>
        <h2>第20条(権利の譲渡)</h2>
        <div>
            ユーザーは、本契約から生じるいかなる権利も第三者への譲渡、質入れその他一切の処分ができないものとします。ただし、当社とユーザーとの間で権利の譲渡の合意がなされた場合を除きます。なお、当社が本件サービスに係る事業を第三者に譲渡する場合、ユーザーは、その本契約上の地位および権利義務が当該第三者に譲渡されることを予め承諾するものとします。
            <br />
        </div>
        <h2>第21条(準拠法/専属的合意管轄裁判所)</h2>
        <div>
            本規約の準拠法は日本法とします。また、当社とユーザーとの間で訴訟の必要が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            <br />
        </div>
        <h2>第22条(協議)</h2>
        <div>
            本規約に定めのない事項および本規約の各条項について疑義が生じた場合、当社およびユーザーが誠意をもって協議し、解決するものとします。
            <br />
        </div>
        <h2>第23条(規約の変更)</h2>
        <div>
            1．当社は、本規約等の内容を変更する必要があると認められる場合、民法第584条の4の定型約款の変更の規定に基づき、本規約等を変更できるものとします。
            <br />
            2．前項による本規約等の変更は、変更後の本規約等の内容を当サイト上その他相当の方法で公表し、公表の際に定める相当の期間を経過した日から適用されるものとします。
            <br />
        </div>
        <h2>第24条(本契約終了後における教室・スクール情報の利用)</h2>
        <div>
            当社は、本契約終了後においても、教室・スクール情報をインターネットユーザーに対して提供する等、当社の事業の範囲において本規約等の定めに従い引き続き利用等することができるものとします。
            <br />
        </div>
        <div className={styles.foot}>
            付則
            <br />
            2022年4月7日制定
        </div>
    </div>
);
